export async function fetchBootstrap() {
  const res = await fetch('/api/bootstrap')
  if (!res.ok) throw new Error('bootstrap fetch failed')
  return res.json()
}

export async function fetchFaqs() {
  const res = await fetch('/api/faqs')
  if (!res.ok) throw new Error('faqs fetch failed')
  return res.json()
}

export async function fetchCampaign() {
  const res = await fetch('/api/campaign')
  if (!res.ok) throw new Error('campaign fetch failed')
  return res.json()
}

export async function fetchDonations() {
  const res = await fetch('/api/donations')
  if (!res.ok) throw new Error('donations fetch failed')
  return res.json()
}

export async function fetchGallery() {
  const res = await fetch('/api/gallery')
  if (!res.ok) throw new Error('gallery fetch failed')
  return res.json()
}

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || ''
}

function appendNested(formData, prefix, attrs) {
  Object.entries(attrs).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    formData.append(`${prefix}[${key}]`, value)
  })
}

export async function postDonation({ donation, personContribution, companyContribution }) {
  const hasFile =
    personContribution?.receipt_file instanceof File ||
    companyContribution?.receipt_file instanceof File

  const headers = { 'X-CSRF-Token': csrfToken() }
  let body

  if (hasFile) {
    const formData = new FormData()
    appendNested(formData, 'donation', donation)
    if (personContribution) appendNested(formData, 'person_contribution', personContribution)
    if (companyContribution) appendNested(formData, 'company_contribution', companyContribution)
    body = formData
  } else {
    const payload = { donation }
    if (personContribution) payload.person_contribution = personContribution
    if (companyContribution) payload.company_contribution = companyContribution
    headers['Content-Type'] = 'application/json'
    body = JSON.stringify(payload)
  }

  const res = await fetch('/api/donations', { method: 'POST', headers, body })
  const responseBody = await res.json()
  if (!res.ok) throw new Error((responseBody.errors || ['error']).join(', '))
  return responseBody
}

export async function createMercadoPagoCheckout({ donation, personContribution, companyContribution, coverProcessingFee }) {
  const payload = { donation, cover_processing_fee: !!coverProcessingFee }
  if (personContribution) payload.person_contribution = personContribution
  if (companyContribution) payload.company_contribution = companyContribution

  const res = await fetch('/api/mercadopago/preferences', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
    },
    body: JSON.stringify(payload)
  })
  const body = await res.json()
  if (!res.ok) throw new Error((body.errors || ['error']).join(', '))
  return body
}
